import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { Col, Form } from "react-bootstrap";
import Select from "react-select";
import { ListOfPdfs, getActiveBanks, saveBankProcess } from "../../../../api";
import "./process.scss";
import * as yup from "yup";
const schema = yup.object({
    bank: yup.array().required("* This filed is required"),
});
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);
import imgNcheck from "../../../../../images/ncheck.svg";

export default function Processors(props) {
 
    const [bank_application, setBankApplication] = useState(
        props.bankApplications ? props.bankApplications : [],
    );
    const [bank_addendum, setBankAddendum] = useState(
        props.bankAddendums ? props.bankAddendums : [],
    );
    const [errors, setError] = useState({

    });

    const [is_submitted, setIsSubmit] = useState(false);
    const [possibleBanks, setPossibleBanks] = useState([]);
    const [possibleAddendums, setPossibleAddendums] = useState([]);
    const [show_spinner, setShowSpinner] = useState(false);

    useEffect(() => {
        loadOptions();
    }, []);

    const loadOptions = () => {
        ListOfPdfs().then((response) => {
            if (response.data.addendums_names) {
                let tempAddendumsArray = [];
                response.data.addendums_names.map((file_name, key) => {
                    tempAddendumsArray.push({
                        value: file_name,
                        label: file_name,
                    });
                });
                setPossibleAddendums(tempAddendumsArray);
            }
        });

        getActiveBanks().then((response) => {
            if (response.status) {
                let tempBankArray = [];
                response.data.map((item) => {
                    tempBankArray.push({
                        value: item.id,
                        label: item.name,
                    });
                });
                setPossibleBanks(tempBankArray);
            }
        });
    };

    const handleSubmitFrom = (data) => {
        const error = {};
        setError(error);
        setShowSpinner(true);
        data.organization_id = props.organization_id;
        saveBankProcess({       
            bank_application,
            bank_addendum,
            organization_id: props.organization_id,
        })
            .then((res) => {
                if (res.status) {
                    MySwal.fire({
                        title: <p>Data saved successfully</p>,
                        iconHtml: `<img src=${imgNcheck} />`,
                        toast: true,
                        position: "right",
                        showConfirmButton: false,
                        timer: 4000,
                        timerProgressBar: true,
                        customClass: "custom-alert-popup alert-success",
                        showCancelButton: false,
                    });
                }
            })
            .catch((err) => {})
            .finally(() => {
                setShowSpinner(false);
            });
    };

    return (
        <div className="row bank-process">
            <Formik
                enableReinitialize
                validationSchema={schema}
                onSubmit={(e) => handleSubmitFrom(e)}
                initialValues={{
                    bank_application,
                    bank_addendum,
                }}
                initialErrors={errors}
                validateOnBlur={true}
                validateOnChange={true}
            >
                {({ handleSubmit, handleChange, values, touched }) => (
                    <Form
                        id="org-process-form"
                        onSubmit={handleSubmit}
                        onChange={(e) => this.updateChange(e)}
                        autoComplete="off"
                    >           
                        <div className="col-12">
                            <div className="col-md-6">
                                <h5 className="title">
                                    Override Bank Application
                                </h5>
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={6}
                                        className="px-3"
                                    >
                                        <Select
                                            isMulti
                                            name="bank_application"
                                            placeholder=""
                                            options={possibleBanks}
                                            value={values.bank_application}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            onChange={(selected) => {
                                                setBankApplication(selected);
                                                setError({
                                                    ...errors,
                                                    bank_application: "",
                                                });
                                            }}
                                            touched={touched.bank_application}
                                            errors={errors.bank_application}
                                            is_submitted={is_submitted}
                                        />
                                        <label className="modal-lab">
                                            Bank Applications
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.bank_application}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                            </div>
                            <div className="col-md-6">
                                <h5 className="title">
                                    Override Bank Addendums
                                </h5>
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Select
                                            isMulti
                                            name="bank_addendum"
                                            placeholder=""
                                            options={possibleAddendums}
                                            value={values.bank_addendum}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            onChange={(selected) => {
                                                setBankAddendum(selected);
                                                setError({
                                                    ...errors,
                                                    bank_addendum: "",
                                                });
                                            }}
                                            touched={touched.bank_addendum}
                                            errors={errors.bank_addendum}
                                            is_submitted={is_submitted}
                                        />
                                        <label className="modal-lab">
                                            Bank Addendums
                                        </label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.bank_addendum}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                {show_spinner ? (
                                    <button
                                        disabled={true}
                                        className="btn float-right confirm-button-loading"
                                    >
                                        <div
                                            class="bar_loader"
                                            title="Processing..."
                                        ></div>
                                    </button>
                                ) : (
                                    <button
                                        form="org-process-form"
                                        type="submit"
                                        onClick={(e) => handleSubmitFrom(e)}
                                        className="btn float-right confirm-button"
                                    >
                                        {" "}
                                        Save
                                    </button>
                                )}
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
}
